import micromarkdown from 'micromarkdown'

export const TextFormatting = {
  filters: {
    markdown: function (val) {
      return micromarkdown.parse(val)
    },
    stripMarkdown: function (val) {
      var html = micromarkdown.parse(val, true)
      html.replace(/<(?:.|\n)*?>/gm, '')
      return html
    },
    stripHtml: function (val) {
      return val.replace(/<(?:.|\n)*?>/gm, '')
    },
  },
  methods: {
    processMarkdown: function (val) {
      return micromarkdown.parse(val)
    },
    processStripMarkdown: function (val) {
      var regex = /(<([^>]+)>)/gi
      var html = micromarkdown.parse(val, true)
      html = html.replace(regex, '')
      return html
    },
  },
}
